import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* TOP SECTION WITH LOGO & SLOGAN */}
        <div className="footer-top">
          {/* LOGO SECTION */}
          <div className="footer-logo-section">
            <div className="footer-logo-container">
              <img 
                src={logo} 
                alt="JCRL Cornerstone Technologies" 
                className="footer-logo-image"
              />
              <div className="footer-logo-text">
                <h3 className="logo-main-footer">
                  <span className="logo-text-footer">JCRL</span>
                  <div className="logo-badge-footer">
                    <span className="logo-subtitle-footer">CORNERSTONE</span>
                    <span className="logo-tagline-footer">Technologies Pvt Ltd.</span>
                  </div>
                </h3>
                <p className="footer-tagline">- Best Software Solution Provider -</p>
              </div>
            </div>
            <p className="footer-description">
              Your trusted partner for Customized Solutions, Expert Support, 
              and Seamless Integration of Workday HCM and Financial Management.
            </p>
            
            {/* COMPANY QUOTE */}
            <div className="footer-quote">
              <div className="quote-icon">💡</div>
              <div className="quote-content">
                <p className="quote-text">
                  "We don't just build software; we engineer solutions that transform businesses."
                </p>
                <span className="quote-author">— Our Development Philosophy</span>
              </div>
            </div>
          </div>
          
          {/* QUICK LINKS & SERVICES IN ONE ROW */}
          <div className="footer-middle-section">
            {/* QUICK LINKS */}
            <div className="footer-links-column">
              <h4 className="footer-heading">
                <span className="footer-heading-text">Quick Links</span>
                <div className="footer-heading-indicator"></div>
              </h4>
              <ul className="footer-links-list">
                <li>
                  <Link to="/" className="footer-link">
                    <div className="link-indicator"></div>
                    <span className="link-text">Home</span>
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="footer-link">
                    <div className="link-indicator"></div>
                    <span className="link-text">Services</span>
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="footer-link">
                    <div className="link-indicator"></div>
                    <span className="link-text">About Us</span>
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="footer-link">
                    <div className="link-indicator"></div>
                    <span className="link-text">Contact</span>
                  </Link>
                </li>
              </ul>
              
              <div className="section-quote compact-quote">
                <div className="section-quote-icon">🚀</div>
                <p className="section-quote-text">
                  "Great software is built on great partnerships."
                </p>
              </div>
            </div>
            
            {/* SERVICES */}
            <div className="footer-links-column">
              <h4 className="footer-heading">
                <span className="footer-heading-text">Services</span>
                <div className="footer-heading-indicator"></div>
              </h4>
              <ul className="footer-links-list">
                <li>
                  <a href="#workday-advisory" className="footer-link">
                    <div className="link-indicator"></div>
                    <span className="link-text">Workday Advisory</span>
                  </a>
                </li>
                <li>
                  <a href="#test-automation" className="footer-link">
                    <div className="link-indicator"></div>
                    <span className="link-text">Test Automation</span>
                  </a>
                </li>
                <li>
                  <a href="#hcm-solutions" className="footer-link">
                    <div className="link-indicator"></div>
                    <span className="link-text">HCM Solutions</span>
                  </a>
                </li>
                <li>
                  <a href="#financial-management" className="footer-link">
                    <div className="link-indicator"></div>
                    <span className="link-text">Financial Management</span>
                  </a>
                </li>
              </ul>
              
              <div className="section-quote compact-quote">
                <div className="section-quote-icon">⚙️</div>
                <p className="section-quote-text">
                  "The best way to predict the future is to implement it."
                </p>
              </div>
            </div>
          </div>
          
          {/* HORIZONTAL CONTACT SECTION */}
          <div className="footer-contact-horizontal">
            <div className="contact-horizontal-content">
              <h4 className="footer-heading">
                <span className="footer-heading-text">Contact Us</span>
                <div className="footer-heading-indicator"></div>
              </h4>
              
              <div className="contact-horizontal-grid">
                <div className="contact-horizontal-item">
                  <div className="contact-icon-horizontal">📍</div>
                  <div className="contact-details-horizontal">
                    <span className="contact-label-horizontal">Address</span>
                    <span className="contact-text-horizontal">
                      Regalia B wing, Casabella, Lodha Palava, Dombivli, Maharashtra, 421204
                    </span>
                  </div>
                </div>
                
                <div className="contact-horizontal-item">
                  <div className="contact-icon-horizontal">📧</div>
                  <div className="contact-details-horizontal">
                    <span className="contact-label-horizontal">Email</span>
                    <a href="mailto:jcrlcornerstonetech@gmail.com" className="contact-text-horizontal">
                      jcrlcornerstonetech@gmail.com
                    </a>
                  </div>
                </div>
                
                <div className="contact-horizontal-item">
                  <div className="contact-icon-horizontal">📞</div>
                  <div className="contact-details-horizontal">
                    <span className="contact-label-horizontal">Phone</span>
                    <a href="tel:+919082916236" className="contact-text-horizontal">
                      +91 9082916236
                    </a>
                  </div>
                </div>
              </div>
              
              <div className="contact-cta-row">
                <div className="contact-quote">
                  <div className="section-quote-icon">🤝</div>
                  <p className="section-quote-text">
                    "Let's build something amazing together."
                  </p>
                </div>
                
                <Link to="/contact" className="footer-cta">
                  <span className="cta-text">Get Free Consultation</span>
                  <div className="cta-arrow">→</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        {/* BOTTOM SECTION */}
        <div className="footer-bottom">
          <div className="footer-divider">
            <div className="divider-line"></div>
            <div className="divider-dot"></div>
            <div className="divider-line"></div>
          </div>
          
          <div className="footer-bottom-content">
            <p className="copyright">
              © 2025 <span className="copyright-highlight">JCRL Cornerstone Technologies Pvt Ltd</span>. All rights reserved.
            </p>
            
            {/* FINAL INSPIRATION QUOTE */}
            <div className="inspiration-quote">
              <span className="inspiration-text">
                "Code is like humor. When you have to explain it, it's bad." – Cory House
              </span>
            </div>
          </div>
          
          <div className="footer-scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="scroll-top-icon">↑</div>
            <span className="scroll-top-text">Back to Top</span>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;